/**
 * Attempt history under a saved prep profile, from canonical results.
 * Presentational. An unmeasured attempt reads "not measured", never 0.
 */
import type { PrepAttempt, PrepProgressSummary } from '../../store/api/interviewPrepApi';
import { progressLine } from '../../utils/interviewPrep';

const KIND_LABEL: Record<PrepAttempt['practiceKind'], string> = { interview: 'Interview', question_drill: 'Single-question drill' };
const MODE_LABEL: Record<PrepAttempt['mode'], string> = { training: 'Practice', testing: 'Test' };

export function PrepHistoryList({ attempts, summary }: { attempts: PrepAttempt[]; summary: PrepProgressSummary }) {
  return (
    <div data-testid="prep-history">
      <p className="text-xs text-gray-600" data-testid="prep-progress">{progressLine(summary)}</p>
      {attempts.length > 0 && (
        <ul className="mt-2 divide-y divide-gray-100 text-sm">
          {attempts.map((a) => (
            <li key={a.sessionId} className="flex items-center justify-between py-1.5">
              <span className="text-gray-700">
                {new Date(a.startedAt).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' })} · {KIND_LABEL[a.practiceKind]} ·{' '}
                {MODE_LABEL[a.mode]}
              </span>
              <span className="tabular-nums text-gray-900" data-measured={a.overall !== null}>
                {a.overall === null ? 'not measured' : Math.round(a.overall)}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default PrepHistoryList;
